import React, { useEffect, useRef } from "react";
import { Link } from "gatsby";
import * as c from "./banner.module.scss";

const Banner = () => {
  const isHiddenRef = useRef(false);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      const offset = Math.max(0, 40 - currentScrollY);
      document.documentElement.style.setProperty("--banner-offset", `${offset}px`);

      if (currentScrollY > 100 && !isHiddenRef.current) {
        isHiddenRef.current = true;
      } else if (currentScrollY < 40 && isHiddenRef.current) {
        isHiddenRef.current = false;
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className={c.banner} role="status" aria-live="polite" aria-label="Announcement">
      <div className={c.content}>
        <span className={c.text}>
          <strong>Introducing Mangomint Connect:</strong> Phone calls, text messages, and web chats.{" "}
          <Link to="/blog/introducing-connect/" className={c.link} aria-label="Learn more about Mangomint Connect">
            Learn more
          </Link>
        </span>
      </div>
    </div>
  );
};

export default Banner;
